<template>
  <v-footer
    height="auto"
    color="blue-grey darken-2"
  >
    <v-layout
      justify-center
      row
      wrap
    >
      <v-btn
        color="white"
        flat
        round
        href="/"
        target="_new"
        >Home</v-btn>
      <v-btn
        color="white"
        flat
        round
        href="/de/hinweise"
        target="_new"
        >Hinweise</v-btn>
      <v-btn
        color="white"
        flat
        round
        href="/de/hilfe/feedback"
        target="_new"
        >Feedback</v-btn>
      <v-flex
        blue-grey
        darken-3
        py-1
        text-xs-center
        white--text
        xs12
      >
        &copy; 2019 - <strong>TARMED Validator</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {
    }
  }
}
</script>

<style>
</style>
